import Icon from '@components/Icon'
import {NOTIF_TYPE_ICON, NOTIF_TYPE_TONE} from '@constants/notification.constant'
import {NOTIFICATION_LIST} from '@constants/internal-route.constant'
import {IColors} from '@interface/common.interface'
import {INotification} from '@interface/notification.interface'
import {NotificationService} from '@services/api/notification.service'
import {FC, useEffect, useState} from 'react'
import Moment from 'react-moment'
import {Link, useNavigate} from 'react-router-dom'

const HeaderNotificationsMenu: FC = () => {
  const navigate = useNavigate()
  const [data, setData] = useState<INotification[]>([])
  const [unreadCount, setUnreadCount] = useState(0)

  const load = () => {
    NotificationService.getList({meta: {itemPerPage: 6, pageNo: 1, orderBy: [], filterBy: []}, body: {}})
      .then((res) => setData(res?.body?.data || []))
      .catch(() => {})
    NotificationService.getUnreadCount()
      .then((res) => setUnreadCount(res?.body || 0))
      .catch(() => {})
  }

  useEffect(() => {
    load()
  }, [])

  const onOpen = (item: INotification) => {
    if (!item.isRead) NotificationService.markRead({id: item.id}).catch(() => {})
    if (item.link) navigate(item.link)
    else navigate(NOTIFICATION_LIST)
  }

  const onMarkAllRead = () => {
    NotificationService.markAllRead()
      .then(() => load())
      .catch(() => {})
  }

  return (
    <div className='menu menu-sub menu-sub-dropdown menu-column w-350px w-lg-375px' data-kt-menu='true'>
      <div className='d-flex flex-column bgi-no-repeat rounded-top bg-primary'>
        <h3 className='text-white fw-bold px-9 mt-10 mb-6'>
          Notifications <span className='fs-8 opacity-75 ps-3'>{unreadCount} unread</span>
        </h3>
      </div>

      <div className='scroll-y mh-325px my-5 px-8'>
        {!data?.length && <div className='text-muted text-center py-6'>No notifications yet.</div>}
        {data?.map((item, i) => {
          const tone = (NOTIF_TYPE_TONE[item.notifType] || 'secondary') as IColors
          const icon = NOTIF_TYPE_ICON[item.notifType] || 'notifications'
          return (
            <div
              key={i}
              className='d-flex flex-stack py-4 cursor-pointer'
              onClick={() => onOpen(item)}
            >
              <div className='d-flex align-items-center'>
                <div className='symbol symbol-35px me-4'>
                  <span className={`symbol-label bg-light-${tone}`}>
                    <Icon icon={icon} color={tone} />
                  </span>
                </div>
                <div className='mb-0 me-2'>
                  <div className={`fs-6 text-gray-800 fw-bolder ${!item.isRead ? '' : 'opacity-75'}`}>
                    {item.title}
                  </div>
                  <div className='text-gray-400 fs-7'>{item.message}</div>
                </div>
              </div>
              <span className='badge badge-light fs-8'>
                <Moment fromNow>{item.insertedOn}</Moment>
              </span>
            </div>
          )
        })}
      </div>

      <div className='py-3 text-center border-top d-flex justify-content-center gap-3'>
        {unreadCount > 0 && (
          <button type='button' className='btn btn-sm btn-color-gray-600 btn-active-color-primary' onClick={onMarkAllRead}>
            Mark all read
          </button>
        )}
        <Link to={NOTIFICATION_LIST} className='btn btn-sm btn-color-gray-600 btn-active-color-primary'>
          View All
        </Link>
      </div>
    </div>
  )
}

export {HeaderNotificationsMenu}
